import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";

export default function Popular() {
  return (
    <section id="popular" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-fire-fill"></i>
              正在流行
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">热门作品</h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
              高口碑、高热度的人气漫画，题材丰富，点开即可进入沉浸式阅读。
            </p>
          </div>
          <Link
            to="/reader"
            className="whitespace-nowrap rounded-md border border-foreground-200 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-500 hover:text-primary-600"
          >
            查看全部 <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 lg:grid-cols-4">
          {comics.map((c) => (
            <article key={c.id} className="group flex flex-col">
              <Link
                to="/reader"
                className="relative block overflow-hidden rounded-lg bg-background-50"
              >
                <img
                  src={c.cover}
                  alt={`${c.title}封面`}
                  className="aspect-[3/4] w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <span
                  className={`absolute left-2 top-2 rounded-full px-2 py-0.5 text-xs text-background-50 ${
                    c.status === "已完结" ? "bg-foreground-700" : "bg-accent-500"
                  }`}
                >
                  {c.status}
                </span>
                <span className="absolute right-2 top-2 flex items-center gap-1 rounded-full bg-background-50/90 px-2 py-0.5 text-xs font-semibold text-primary-600 backdrop-blur">
                  <i className="ri-star-fill text-accent-500"></i>
                  {c.rating.toFixed(1)}
                </span>
              </Link>

              <h3 className="mt-3 font-heading text-sm font-bold text-foreground-950 md:text-base">
                <Link to="/reader" className="hover:text-primary-600 transition-colors">
                  {c.title}
                </Link>
              </h3>
              <p className="mt-1 text-xs text-foreground-500">{c.author} · 共{c.chapters}话</p>
              <div className="mt-2 flex flex-wrap items-center gap-1.5">
                <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-xs text-secondary-900">{c.category}</span>
                {c.tags.slice(0, 2).map((t) => (
                  <span key={t} className="rounded bg-background-200/70 px-1.5 py-0.5 text-xs text-foreground-600">
                    {t}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}